module.exports = __webpack_public_path__ + "static/battle_01-9b4108f8113d57297a6172cf60fb5b13.jpg";